import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody } from 'reactstrap';

import BloodPressureChart from './bloodPressure';
import BloodGlucoseChart from './bloodGlucose';
import Pulse from './pulse';
import Weight from './weight';
import SpO2 from './spO2';
import TemperatureChart from './temperatureChart';
import SleepMatChart from './sleepMatChart';
import PeakFlowChart from './peakFlow';

const Charts = ({ patient, patientDetailsLoading, chartsLoading }) => {
  const glucoseChart = patient.charts.bloodGlucose;
  const bloodPressureChart = patient.charts.bloodPressure;
  const weightChart = patient.charts.weight;
  const spO2Chart = patient.charts.spO2;
  const temperatureChart = patient.charts.temperature;
  const sleepingMatDurationChart = patient.charts.sleepingMatDuration;
  const peakFlowChart = patient.charts.peakFlow;

  let pulseChart;
  if (bloodPressureChart) {
    pulseChart = [...bloodPressureChart];
  }

  if (spO2Chart) {
    pulseChart = [...pulseChart, ...spO2Chart];
  }

  if (pulseChart && pulseChart.length > 0) {
    pulseChart.sort((a, b) => +a.createdAt - +b.createdAt);
  }

  const showPulse =
    !patientDetailsLoading && !chartsLoading && pulseChart?.length > 0;
  const showGlucose =
    !patientDetailsLoading && !chartsLoading && glucoseChart?.length > 0;
  const showBloodPressure =
    !patientDetailsLoading && !chartsLoading && bloodPressureChart?.length > 1;
  const showWeight =
    !(patientDetailsLoading && chartsLoading) && weightChart?.length > 0;
  const showSpO2 =
    !patientDetailsLoading && !chartsLoading && spO2Chart?.length > 0;
  const showTemperatureChart =
    !patientDetailsLoading && !chartsLoading && temperatureChart?.length > 0;
  const showSleepMatChart =
    !patientDetailsLoading &&
    !chartsLoading &&
    sleepingMatDurationChart?.length > 0;
  const showPeakFlowChart =
    !(patientDetailsLoading && chartsLoading) && peakFlowChart?.length > 0;

  return (
    <div className="charts">
      {showPeakFlowChart && (
        <PeakFlowChart
          data={peakFlowChart}
          loading={patientDetailsLoading || chartsLoading}
          thresholds={patient.thresholds}
        />
      )}
      {showBloodPressure && (
        <div className="chart-item">
          <Card className="card-border">
            <CardBody>
              <div className="charts-body">
                <BloodPressureChart
                  data={bloodPressureChart}
                  loading={patientDetailsLoading || chartsLoading}
                  thresholds={patient.thresholds}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      )}
      {showPulse && (
        <div className="chart-item">
          <Card className="card-border">
            <CardBody>
              <div className="charts-body">
                <Pulse
                  data={pulseChart}
                  loading={patientDetailsLoading || chartsLoading}
                  thresholds={patient.thresholds}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      )}
      {showGlucose && (
        <div className="chart-item">
          <Card className="card-border">
            <CardBody>
              <div className="charts-body">
                <BloodGlucoseChart
                  data={glucoseChart}
                  loading={patientDetailsLoading || chartsLoading}
                  thresholds={patient.thresholds}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      )}
      {showWeight && (
        <div className="chart-item">
          <Card className="card-border">
            <CardBody>
              <div className="charts-body">
                <Weight
                  data={weightChart}
                  loading={patientDetailsLoading || chartsLoading}
                  thresholds={patient.thresholds}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      )}
      {showSpO2 && (
        <div className="chart-item">
          <Card className="card-border">
            <CardBody>
              <div className="charts-body">
                <SpO2
                  data={spO2Chart}
                  loading={patientDetailsLoading || chartsLoading}
                  thresholds={patient.thresholds}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      )}
      {showTemperatureChart && (
        <div className="chart-item">
          <Card className="card-border">
            <CardBody>
              <div className="charts-body">
                <TemperatureChart
                  data={temperatureChart}
                  loading={patientDetailsLoading || chartsLoading}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      )}
      {showSleepMatChart && (
        <div className="chart-item">
          <Card className="card-border">
            <CardBody>
              <div className="charts-body">
                <SleepMatChart
                  data={sleepingMatDurationChart}
                  loading={patientDetailsLoading || chartsLoading}
                  thresholds={patient.thresholds}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      )}
    </div>
  );
};

Charts.propTypes = {
  patientDetailsLoading: PropTypes.bool.isRequired,
  chartsLoading: PropTypes.bool.isRequired,
  patient: PropTypes.shape(),
};

export default Charts;
